import React from 'react';
import { FadeIn } from './ui/FadeIn';
export const AboutAuthor = () => {
  return <section className="py-20 md:py-24 bg-dark-card border-y border-white/5 relative" data-id="element-11">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-neon/5 rounded-full blur-[100px] pointer-events-none" data-id="element-12" />

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="text-center mb-10" data-id="element-15">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-16">
              Quién está detrás de este plan
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-17">
              Creado por alguien que estuvo exactamente donde tú estás ahora
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-18">
          <div className="bg-[#111111] border border-white/10 rounded-2xl p-8 md:p-10 space-y-5" data-id="element-19">
            <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-20">
              Hace algunos años estaba buscando formas de generar dinero extra
              sin tener que renunciar a mi trabajo ni invertir dinero que no
              tenía.
            </p>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-21">
              Probé de todo. La mayoría no funcionaba o tardaba meses.
            </p>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-22">
              Lo que sí funcionó lo documenté, lo organicé en pasos concretos y
              lo convertí en este plan.
            </p>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-23">
              No soy un gurú de internet. Soy alguien que encontró un sistema
              que funciona y lo está compartiendo al precio más accesible
              posible.
            </p>
            <p className="text-base md:text-lg text-white leading-relaxed font-sans m-0 pt-4 border-t border-white/10" data-id="element-24">
              Por eso el precio es{' '}
              <span className="text-[#ADFF2F] font-bold" data-id="element-25">$6.39</span> y no $97.
              Quiero que lo pueda aplicar cualquier persona sin importar su
              situación económica.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};